import React, { useEffect, useState } from "react";
import { Box, Button, ButtonGroup, Grid, Typography } from "@mui/material";
import AccordionDetailsUi from "./AccordionDetailsUi";

import itePrimeWhite from "../../../assets/images/ITE_PRIME_WHITE.svg";
import iteOptimaBlack from "../../../assets/images/ITE_OPTIMA_BLACK.svg";
import METALIC_RIC_OPTIMA from "../../../assets/images/metalic_ric.svg";
import ric8WithoutDome from "../../../assets/images/WITHOUT DOME.svg";
import BTE from "../../../assets/images/Frame_34320[1].png";
import { DRUM, WAX, DEVICES, DEVICES_NAME } from "../../../utils/constants";
import HearnuPro from "../../../assets/images/HearnuPro.png";

const SuggestedDevices = ({ fields, setFields }) => {
  const [suggestedProduct, setSuggestedProduct] = useState([]);
  const [device, setDevice] = useState(
    Number(fields?.product) ? Number(fields?.product) : fields?.type);
  const [hasLoss, setHasLoss] = useState();
  const [selectButton, setselectButton] = useState("Suggested_Devices");

  const getProductsForLoss = (allLeftEqualTo70, lossLevel) => {
    const products = new Set();

    if (lossLevel === 70 && allLeftEqualTo70) {
      products.add(DEVICES.BTE_OPTIMA).add(DEVICES.BTE_PRIME);
      setHasLoss(true);
    }
    if (lossLevel >= 30 && lossLevel <= 69) {
      products.add(DEVICES.ITE_OPTIMA).add(DEVICES.ITE_PRIME);
      setHasLoss(true);
    }
    if (lossLevel >= 30 && lossLevel <= 85 && !allLeftEqualTo70) {
      products
        .add(DEVICES.RIC_OPTIMA_8)
        .add(DEVICES.RIC_OPTIMA)
        .add(DEVICES.RIC_32);
      setHasLoss(true);
    }

    if (lossLevel >= 70 && lossLevel <= 100 && !allLeftEqualTo70) {
      products.add(DEVICES.BTE_OPTIMA).add(DEVICES.BTE_PRIME);

      setHasLoss(true);
    }

    return Array.from(products);
  };

  const getProductsForEarDrum = () => {
    const products = new Set();

    if (fields?.is_discharge_left || fields?.is_discharge_right) {
      products.add(DEVICES.BTE_OPTIMA).add(DEVICES.BTE_PRIME);
      setHasLoss(true);
    } else {
      setHasLoss(true);
      products
        .add(DEVICES.BTE_OPTIMA)
        .add(DEVICES.BTE_PRIME)
        .add(DEVICES.RIC_OPTIMA_8)
        .add(DEVICES.RIC_OPTIMA)
        .add(DEVICES.RIC_32)
        .add(DEVICES.ITE_OPTIMA)
        .add(DEVICES.ITE_PRIME);
    }

    return Array.from(products);
  };

  useEffect(() => {
    const allLeftEqualTo70 = [
      fields?.lf1,
      fields?.lf2,
      fields?.lf3,
      fields?.lf4,
      fields?.lf5,
      fields?.lf6,
      fields?.lf7,
    ].every((value) => value == 70);

    const allRightEqualTo70 = [
      fields?.rf1,
      fields?.rf2,
      fields?.rf3,
      fields?.rf4,
      fields?.rf5,
      fields?.rf6,
      fields?.rf7,
    ].every((value) => value == 70);

    const left = (fields?.lf3 + fields?.lf4 + fields?.lf5) / 3 || 0;
    const right = (fields?.rf3 + fields?.rf4 + fields?.rf5) / 3 || 0;

    const newProductsLeft =
      fields?.left_eardrum === DRUM.PERFORATED
        ? getProductsForEarDrum()
        : getProductsForLoss(allLeftEqualTo70, left);

    const newProductsRight =
      fields?.right_eardrum === DRUM.PERFORATED
        ? getProductsForEarDrum()
        : getProductsForLoss(allRightEqualTo70, right);

    const leftSet = new Set(newProductsLeft);
    const rightSet = new Set(newProductsRight);

    const both = [];
    const rightOnly = [];
    const leftOnly = [];

    for (const d of leftSet) {
      if (rightSet.has(d)) {
        both.push({ side: "Both", product: d });
      } else {
        leftOnly.push({ side: "Left", product: d });
      }
    }

    setSuggestedProduct([...both, ...rightOnly, ...leftOnly]);
  }, [
    fields.lf3,
    fields.lf4,
    fields.lf5,
    fields.rf3,
    fields.rf4,
    fields.rf5,
    fields.left_eardrum,
    fields.right_eardrum,
    fields.is_discharge_left,
    fields.is_discharge_right,
  ]);

  const SuggestedProductData = (productType) => {
    const updateSuggestedProduct = (selectedDevice) => {
      setDevice(selectedDevice);
      setFields((prev) => ({
        ...prev,
        product: selectedDevice,
        type: selectedDevice,
      }));
    };

    const baseConfig = {
      border: device === productType,
      backgroundColor: device === productType,
    };

    switch (productType) {
      case DEVICES.BTE_OPTIMA:
        return {
          ...baseConfig,
          src: BTE,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.BTE_OPTIMA),
        };
      case DEVICES.POWER_BTE:
        return {
          ...baseConfig,
          src: BTE,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.POWER_BTE),
        };

      case DEVICES.BTE_PRIME:
        return {
          ...baseConfig,
          src: BTE,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.BTE_PRIME),
        };

      case DEVICES.RIC_OPTIMA_8:
        return {
          ...baseConfig,
          src: ric8WithoutDome,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_OPTIMA_8),
        };
      case DEVICES.HEAR_NU:
        return {
          ...baseConfig,
          src: HearnuPro,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.HEAR_NU),
        };

      case DEVICES.RIC_OPTIMA:
        return {
          ...baseConfig,
          src: METALIC_RIC_OPTIMA,
          sideColor: {
            METALIC: "#C6C1C5",
            BLACK: "#000000",
            BEIGE: "#D6B19F",
          },
          OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_OPTIMA),
        };

      case DEVICES.RIC_32:
        return {
          ...baseConfig,
          src: METALIC_RIC_OPTIMA,
          sideColor: {
            METALIC: "#C6C1C5",
            BLACK: "#000000",
            BEIGE: "#D6B19F",
          },
          OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_32),
        };

      case DEVICES.ITE_OPTIMA:
        return {
          ...baseConfig,
          src: iteOptimaBlack,
          sideColor: { BLACK: "#000000", WHITE: "#FFFFFF" },
          OnClickCenter: () => updateSuggestedProduct(DEVICES.ITE_OPTIMA),
        };

      case DEVICES.ITE_PRIME:
        return {
          ...baseConfig,
          src: itePrimeWhite,
          OnClickCenter: () => updateSuggestedProduct(DEVICES.ITE_PRIME),
        };

      default:
        return {};
    }
  };

    useEffect(() => {
        if (suggestedProduct.length == 0) {
            setselectButton("All_Devices");
        }
    }, [suggestedProduct.length]);
  return (
    <Box mb={1}>
      <ButtonGroup sx={{ display: "flex", width: "100%", mb: 3, mt: 1 }}>
        {suggestedProduct.length !== 0 && (
          <Button
            sx={{
              fontFamily: "League spartan",
              width: "50%",
              display: "flex",
              justifyContent: "center",
              backgroundColor:
                selectButton === "Suggested_Devices" ? "#EDF0F7" : "white",
              border:
                selectButton === "Suggested_Devices" ? "1px solid #2D3B67" : "",
            }}
            onClick={() => {
              setselectButton("Suggested_Devices");
            }}
          >
            <Typography
              fontWeight={700}
              fontSize={"16px"}
              sx={{ color: "#2D3B67" }}
            >
              Suggested Devices
            </Typography>
          </Button>
        )}
        <Button
          sx={{
            fontFamily: "League spartan",
            width: "50%",
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              selectButton === "All_Devices" ? "#EDF0F7" : "white",
            border: selectButton === "All_Devices" ? "1px solid #2D3B67" : "",
          }}
          onClick={() => {
            setselectButton("All_Devices");
          }}
        >
          <Typography
            fontWeight={700}
            fontSize={"16px"}
            sx={{ color: "#2D3B67" }}
          >
            All Devices
          </Typography>
        </Button>
      </ButtonGroup>
      {selectButton === "Suggested_Devices" && (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            {suggestedProduct.map((item, idx) => {
              const data = SuggestedProductData(item.product);
              return (
                <Grid item xs={12} sm={6} md={2} key={`${item.product}-${idx}`}>
                  <AccordionDetailsUi
                    side={data?.IsOnlyBoth ? data?.IsOnlyBoth : item.side}
                    setDevice={setDevice}
                    Title={DEVICES_NAME[item.product]}
                    setFields={setFields}
                    sideColor={data?.sideColor}
                    // Right_src={RIGHT}
                    // Center_src={CENTER}
                    // Left_src={LEFT}
                    isBorder={data?.border}
                    isBackgroundColor={data?.backgroundColor}
                    img_src={data?.src}
                    OnClickCenter={data?.OnClickCenter}
                    device={item.product}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}
      {selectButton === "All_Devices" && (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            {Object.entries(DEVICES).map(([key, value], idx) => {
              const data = SuggestedProductData(value);
              return (
                <Grid item xs={12} sm={6} md={2} key={`${value}-${idx}`}>
                  <AccordionDetailsUi
                    side={data?.IsOnlyBoth ? data?.IsOnlyBoth : data?.side}
                    setDevice={setDevice}
                    Title={DEVICES_NAME[value]}
                    setFields={setFields}
                    sideColor={data?.sideColor}
                    isBorder={data?.border}
                    isBackgroundColor={data?.backgroundColor}
                    img_src={data?.src}
                    OnClickCenter={data?.OnClickCenter}
                    device={value}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default SuggestedDevices;
